import { Component,  Input, OnChanges } from '@angular/core';
import { Subject } from 'rxjs';
import { PublicEventInfo, PublicTimelineItem } from 'globals/store/public.model';
import { removeOrAddToListByElement } from '../../helpers/helpers';
import { CommonModule } from '@angular/common';
import { JoiNavWrapper } from '../wrappers/joi-nav-wrapper.component';
import { PublishTimelineItemComponent } from './publish-timeline-item';

@Component({
    selector: 'publish-timeline-view',
    templateUrl: './publish-timeline-view.html',
    styleUrls: ['./publish-timeline-view.scss'],
    standalone: true,
    imports: [CommonModule, PublishTimelineItemComponent, JoiNavWrapper],
})
export class PublishTimelineViewComponent implements OnChanges {
  @Input() timeline: PublicTimelineItem[][]
  @Input() programTexts: { [programId: string]: string } = {}
  @Input() excludedFieldIds: string[] = []
  @Input() joiEvent: PublicEventInfo
  @Input() $toggleAll: Subject<boolean>
  @Input() userSelectedTimezone
  @Input() checkedSessionIds: string[]
  @Input() breakDays: boolean = false
  @Input() sponsorsCustomTitle?: string

  menuItems: string[] = []
  menuMap: { [id: string]: string } = {}
  selectedDay = 0
  parseInt = parseInt


  trackByIndex(index) {
    return index
  }

  ngOnChanges() {
    if (!this.timeline || !this.timeline.length) return 
    if (this.timeline.length <= this.selectedDay) this.selectedDay = 0
    
    this.menuItems = this.timeline.map((t,i) => `${i}`)
    this.menuMap = {}
    this.menuItems.forEach((t,i) => this.menuMap[`${i}`] = `Day ${i + 1}`)
    
  }

  toggleChecked(sessionId: string) {
    removeOrAddToListByElement(this.checkedSessionIds, sessionId)
  }

}

